import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { NotOverridableSponsorBannerKeys } from 'src/app/_constants';
import { NotOverridableSponsorBannerKeysType, Sponsor } from 'src/app/_interfaces';
import { SsrAdService } from 'src/app/_services/ssr-ad.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-sponsor-banner',
    templateUrl: './sponsor-banner.component.html',
    styleUrls: ['./sponsor-banner.component.scss']
})
export class SponsorBannerComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() sponsor_key: string = '';
    @Input() entry_sponsor?: Sponsor;
    @Input() aspect_ratio: string = '16:9';
    @Input() location?: string = ``;
    @Input() margin?: string = ``;

    public sponsor: Sponsor | null = null;

    private subs = new Subscription();

    constructor(
        private ssrAds: SsrAdService
    ) { }

    async ngOnInit() {
        if (Object.keys(this?.entry_sponsor || {})?.length) {
            this.sponsor = this.entry_sponsor!;
            return;
        }

        this.subs.add(
            this.ssrAds.adPool$.subscribe(() => {
                this.refreshSponsor();
            })
        );

        this.subs.add(
            this.ssrAds.videoAdSponsor.subscribe((sponsor) => sponsor && this.overrideSponsorBanner(sponsor!))
        );

        this.refreshSponsor();
        this.overrideSponsorBanner(this.ssrAds.get__videoAd()?.[0]?.sponsor as any);
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.postBannerEvent(this.location ?? 'Sponsor banner visible'), 0);
    }

    private refreshSponsor(): void {
        if (!this.sponsor_key) {
            return;
        }
        this.sponsor = this.ssrAds.getSponsor(this.sponsor_key) ?? null;
    }

    overrideSponsorBanner(sponsor: Sponsor): void {
        this.sponsor = this.ssrAds.getSponsor(this.sponsor_key);

        if (
            this.sponsor
            && sponsor?.id
            && !NotOverridableSponsorBannerKeys.includes(this.sponsor_key as NotOverridableSponsorBannerKeysType)
        ) {
            this.sponsor = sponsor;
        }
    }

    openLink() {
        const raw = this.sponsor?.url ?? '';
        const url = raw.includes('https://') ? raw : `https://${raw}`;

        if (url.includes('bleachr://iap')) {
            return;
        }

        window.open(url, '_blank');
    }

    postEvent(): void {
        if (this.sponsor && this.sponsor_key) {
            const should_override: boolean = this.ssrAds.get__videoAd()?.[0]?.sponsor?.id ? true : false;
            const key: string = should_override ? `${this.sponsor_key}-overridden` : this.sponsor_key;
            this.ssrAds.postEvent(key, {});
        }

        this.postBannerEvent(`Sponsor banner tapped`);
        this.openLink();
    }

    postBannerEvent(event: string = `Sponsor banner visible`) {
        const sponsor_location = this.sponsor?.key === `homescreen-rotation` ? `Home` : this.sponsor?.key;
        const payload = {
            key: this.sponsor?.key,
            event,
            sponsor_id: this.sponsor?.id,
            sponsor_name: this.sponsor?.name,
            sponsor_location,
            sponsor_campaign_id: this.sponsor?.sponsor_campaign_id
        };

        this.ssrAds.postEvent(`sponsor`, payload)?.then(() => {
            this.refreshSponsor();
        });
    }

    get imageSrc() {
        return this.sponsor ? this.sponsor.image_url : '';
    }

    get imageAspectRatio() {
        return this.aspect_ratio.replace(':', '/');
    }
}
